export const AVAILABLE_LANGS: string[] = ['en', 'es']
export const TRANSLOCO_SCOPE: string = 'auth'
